// store.js
import { writable } from "svelte/store";
export const initVal = {
    headrest: false,
    lateralSupport: false,
    backrest: "normal",
    dropdownArmrest: false,
};
export const configStore = writable(initVal);
